import { render, staticRenderFns } from "./FeaturedItems3.vue?vue&type=template&id=068c2c30"
import script from "./FeaturedItems3.vue?vue&type=script&lang=js"
export * from "./FeaturedItems3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports